import React from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { markFirstGameGuideSeen } from "@/components/FirstGameGuide";

// New player induction (Jack, 2026-10-16): 1 raider, 2 How to play video,
// 3 a demo game against Rookie Rufus on Classic. Skippable at any step.
export const INDUCTION_STEPS = ["Your raider", "How to play", "Demo game"];

export default function InductionSteps({ step }) {
  const { user } = useAuth();
  const navigate = useNavigate();
  const skip = () => {
    // The video won't pop up again before their first real game.
    markFirstGameGuideSeen(user);
    navigate("/lobby", { replace: true });
  };
  return (
    <div className="flex items-center justify-between gap-3 mb-5" data-testid="induction-steps">
      <ol className="flex items-center gap-1.5 min-w-0 flex-wrap">
        {INDUCTION_STEPS.map((label, i) => {
          const n = i + 1;
          const state = n < step ? "done" : n === step ? "now" : "next";
          return (
            <li key={label} className="flex items-center gap-1.5">
              <span
                className={`w-6 h-6 rounded-full text-[11px] font-bold flex items-center justify-center flex-none ${
                  state === "now" ? "bg-brand text-brand-foreground" : state === "done" ? "bg-brand/25 text-brand" : "bg-muted text-muted-foreground"
                }`}
              >
                {n}
              </span>
              <span className={`text-xs font-semibold ${state === "now" ? "text-foreground" : "text-muted-foreground"} ${state === "now" ? "" : "hidden sm:inline"}`}>
                {label}
              </span>
              {n < INDUCTION_STEPS.length && <span className="w-4 h-px bg-border mx-0.5" aria-hidden />}
            </li>
          );
        })}
      </ol>
      <button
        type="button"
        onClick={skip}
        className="text-xs font-semibold text-muted-foreground hover:text-foreground underline underline-offset-4 flex-none"
        data-testid="induction-skip"
      >
        Skip tutorial
      </button>
    </div>
  );
}
